import React from "react";
import { FeedbackMark } from "./SectionSpinnerV4";
import type { ButtonFeedback } from "../sequence/sequenceStateV4";

export type ButtonV4Variant =
  "primary" | "ok" | "confirm" | "danger" | "ghost" | "danger-ghost" | "plain";

export type ButtonV4Size = "md" | "sm" | "icon";

type ButtonV4Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonV4Variant;
  size?: ButtonV4Size;
  pill?: boolean;
  selected?: boolean;
  // ข้อความยาวขึ้นบรรทัดใหม่
  wrap?: boolean;
  /** สถานะ action ของปุ่มนี้จาก buttonLoadCheck ("loading"|"done"|"error"|"idle") - ดู SectionSpinnerV4/makeActionFeedback */
  feedback?: ButtonFeedback;
  // ข้อความ tooltip บอกผู้ใช้ว่าปุ่มนี้กำลังทำอะไร
  feedbackLabel?: string;
};

/** ปุ่มของ HIS V4 (class hv4-btn ใน _hisv4-base.scss) */
const ButtonV4 = ({
  variant,
  size = "md",
  pill = false,
  selected = false,
  wrap = false,
  feedback = "idle",
  feedbackLabel,
  className,
  type = "button",
  disabled,
  ...props
}: ButtonV4Props) => {
  const classes = [
    "hv4-btn",
    variant && `hv4-btn-${variant}`,
    size !== "md" && `hv4-btn-${size}`,
    pill && "hv4-btn-pill",
    selected && "hv4-btn-selected",
    wrap && "hv4-btn-wrap",
    className,
  ];

  const busy = feedback === "loading";

  /* หมายเหตุ: ไม่บังคับ disabled ให้ - แต่ละการ์ดมี gate ของตัวเอง (เช่น gate ตามความครบของข้อมูล)
     ถ้าจะกันกดซ้ำ ให้การ์ดส่ง disabled มาเอง */
  return (
    <button
      type={type}
      className={classes.filter(Boolean).join(" ")}
      disabled={disabled}
      aria-busy={busy || undefined}
      title={feedbackLabel ?? props.title}
      {...props}
    >
      {props.children}
      <FeedbackMark feedback={feedback} label={feedbackLabel} />
    </button>
  );
};

ButtonV4.displayName = "ButtonV4";

export default ButtonV4;
